webpackJsonp([44],{

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'amp-card-cover',
  props: ['node'],
  computed: {
    ndoeTitle: function ndoeTitle() {
      return (0, _get2.default)(this.node, 'title', 'Abacus');
    },
    cardImgSrc: function cardImgSrc() {
      var image = (0, _utilities.getImageByType)((0, _get2.default)(this.node, 'images', []), 'card_mobile');
      return (0, _get2.default)(image, 'full', '/image/placeholder/32/40/5A9CB5/20');
    }
  }
};

/***/ }),

/***/ 1686:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1342),
  /* template */
  __webpack_require__(1725),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1725:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardCover"
  }, [_c('amp-img', {
    attrs: {
      "src": _vm.cardImgSrc,
      "alt": _vm.ndoeTitle,
      "height": "1118",
      "width": "750",
      "layout": "responsive"
    }
  })], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 44.b9038dc87c988504ebfd.js